import PagesService from "@/api/services/pagesService";
import { CustomPage } from "@/interfaces/Pages/CustomPage.ts";
import { defineStore } from "pinia";

interface CustomPageState {
  pages: Partial<Record<string, CustomPage>>;
  props: Partial<Record<string, any>>;
}

export const useCustomPageStore = defineStore("customPage", {
  state: (): CustomPageState => ({
    pages: {},
    props: {},
  }),

  getters: {
    getProps: (state: CustomPageState) => (url: string) => state.props[url],
    getCustomPage: (state: CustomPageState) => (url: string) => state.pages[url],
  },

  actions: {
    addProps(url: string, props: Record<string, any>) {
      this.props[url] = props;
    },
    async fetchCustomPage(url: string, password: string | null): Promise<CustomPage> {
      const page: CustomPage = await PagesService.get(url, password);

      if (page && !page.has_password) {
        this.pages[url] = page;
      }

      return page;
    },
  },
});
